import { baseApi } from "./baseQuery";

// Helper function to get workspace ID from localStorage (now ObjectId)
const getWorkspaceId = (): string => localStorage.getItem("workspace_id") ?? "Demo";

const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({

    createPaymentLink: build.mutation({
      query: (body) => ({
        url: "/api/v1/create-payment-link",
        method: "POST",
        body: body
      }),
    }),

    purchasePlanBilling: build.mutation({
      query: (body) => ({
        url: "/api/v1/purchase-plan-billing",
        method: "POST",
        body: body
      }),
      invalidatesTags: ['currentPlan']
    }),

    getCurrentPlan: build.query({
      query: () => {
        return {
          url: `/api/v1/get-purchase-plan-billing`,
        }
      },
      providesTags: ['currentPlan']
    }),

    purchaseQuery: build.mutation({
      query: (body) => ({
        url: "/api/v1/buy-query-limit",
        method: "POST",
        body: body
      }),
      invalidatesTags: ['currentPlan']
    }),


     printInvoice: build.query({
      query: (session_id) => ({
        url: `/api/v1/download-stripe-invoice?session_id=${session_id}&workspace_id=${getWorkspaceId()}`,
        method: "GET",
        // responseHandler: ((response) => response.blob())
      }),
      keepUnusedDataFor:0
    }),


  }),

  // @ts-ignore
  overrideExisting: module.hot?.status() === "apply",
});

export const {
  useCreatePaymentLinkMutation,
  usePurchasePlanBillingMutation,
  useGetCurrentPlanQuery,
  usePurchaseQueryMutation,
  usePrintInvoiceQuery
} = authApi;
